<template>
  <div>

   <!--<pre>{{ categorWiseRoom }}</pre> -->
        <!-- <pre> {{categorWiseRoom}}</pre>
        <pre>{{ assets }}</pre> -->
         <!--<pre>{{settings_obj}}</pre> -->
    <form class="flex flex-wrap items-center relative py-3" data-vv-scope="Add_Equipment">
      <div v-for="(i, index) in 2" :key="index" :class="[index == 0 ? 'rooms_holder' : 'inventory_holder']">
        <div class="sm:w-1/2 w-full px-2 sm:my-5 my-3" v-for="(eachQuipment, index) in categorWiseRoom" :key="index">
          <p class="heading_facilities w-full" v-if="eachQuipment.category_name == 'Room' || eachQuipment.category_name == 'Capacity' && index == 0">
            <span class="inline-block">Rooms</span></p>
          <p class="heading_facilities w-full" v-if="index == 2">
            <span class="inline-block">Inventories</span>
          </p>
          <div class="inline-flex flex-wrap items-center w-full">
            <label class="inline-block facility_label">{{
              eachQuipment.category_name
            }}</label>
            <div style="width: 120px;" v-if="eachQuipment.category_name== 'Capacity'">
                 <vs-input
                class="w-full"
                type="number"
                placeholder="Enter Quantity"
                v-model="eachQuipment.no_of_assets"
                v-validate="`numeric`"
                :name="eachQuipment.category_name"
              />
            </div>
            <div style="width: 120px;" v-else>
            <vs-input
                class="w-full"
                type="number"
                placeholder="Enter Quantity"
                v-model="eachQuipment.no_of_assets"
                v-validate="`numeric|min_value:0|max_value:${eachQuipment.quantity}`"
                :name="eachQuipment.category_name"
              />
            </div>
            <!-- {{ eachQuipment.no_of_assets }} -->
            <div
              v-if="errors.has(`Add_Equipment.${eachQuipment.category_name}`)"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first(`Add_Equipment.${eachQuipment.category_name}`) }}
            </div>
          </div>
        </div>
      </div>
      <vs-button class="ml-auto" @click="saveEquimentToCourse()"
        >Save Equipment</vs-button
      >
    </form>
  </div>
</template>
<script>
import { roomInventory } from '@/mixins/Rooms/roomInventory.js'

export default {
  mixins: [roomInventory],
  props: {
    assets: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      equipment_assets: [],
      equipment_id: [],
      number_input: null,
      categorWiseRoom: []
    }
  },
  mounted () {
    //   
    // 
    // const customer_id = localStorage.getItem('customer_id')
    // this.fetchEquipment(customer_id)
    const payload = {
      room: true,
      capacity: true
    }
    const fetchingCategory = this.fetchingAssetsInventoryName(payload)
    
    fetchingCategory.then((res) => {
      
      if (res) {
        
        this.categorWiseRoom = this.inventoryNameList.map((ele) => ({
          ...ele,
          no_of_assets: this.getNoOfAssets(ele.id),
          asset_id: ele.id
        }))
        // const filteredData = this.categorWiseRoom.filter((ele) => {
        //   return ele.category_name == 'Room'
        // })
        // if (filteredData.length != 0) {
        //   const insertedElement = {
        //     'assets_categories_id': 0,
        //     'category_name': 'Capacity',
        //     'is_active': 1,
        //     'no_of_assets': null,
        //     'asset_category_id': 0,
        //     'room_capacity': 0
        //   }
        //   this.categorWiseRoom.splice(1, 0, insertedElement)
        //}
      } else {
        
      }
    })
  },
  methods: {
    saveEquimentToCourse () {
      //&& ele.category_name !== 'Capacity'
      const payload = this.categorWiseRoom.filter((ele) => {
        return ele.no_of_assets > 0
      })
      payload.map((ele) => {
        ele.no_of_assets = Number(ele.no_of_assets)
      })
      // const findCapacity = this.categorWiseRoom.filter((ele) => {
      //   return ele.category_name === 'Capacity'
      // })
      // const objIndex = payload.findIndex((obj => obj.category_name === 'Room'))
      // payload[objIndex].room_capacity = Number(findCapacity[0].no_of_assets)
      
      // console.log(payload)
      this.$emit('getAssetsValue', payload)
      // 
    },
    /* async fetchEquipment (customer_id) {
      try {
        const {data} = await getCourseEquipment(customer_id)
        this.equipment_assets = data.data[0]
        this.equipment_assets.forEach(ele => {            
          this.equipment_id.push({
            asset_type_id:ele.id,
            no_of_equipment:this.getEquipment(ele.id),
            roomname:ele.asset_name
          })
        })
        
      } catch (error) {
        
      }
    }, */
    getNoOfAssets (id) {
      const roomArray = this.assets.filter(ele => {
        return  ele.asset_id == id
      })
      
      if (roomArray.length) {
        return roomArray[0].no_of_assets
      } else { 
        return null 
      }

    }
    /*   saveEquimentToCourse () {
      this.$validator.validateAll('Add_Equipment').then(valid => {
        if (valid) {
          
          
          const filteredEquiment = this.equipment_id.filter(ele => {
            
            return parseInt(ele.no_of_equipment) >= 1
          })
          if (filteredEquiment.length) {
            const payload = {
              course_id:this.course_id,
              equipments:filteredEquiment
            }
            this.savingEquipment(payload)
          } else {
            
          }
        } else {
          
        }
      })
    },
    async savingEquipment (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const data = await saveCourseEquipment(payload, customer_id)
        
        this.showSuccessMessage('Success', 'Equipment Update successfully', 'success')

      } catch (error) {
        
      }
    } */
  }
}
</script>
<style scoped>
</style>